<div class="map-actions light-right">
  @if (backBtn) {
    <a
      class="light-btn-link colour-text-main"
      (click)="closeMapView.emit()"
      (keydown.enter)="closeMapView.emit()"
      tabindex="0"
      role="link"
      i18n="@@mapViewsBackToList"
      >Back to list view</a
    >
  }
</div>
<div class="map-container" tabindex="-1">
  <google-map [style.height.px]="height" [usePanning]="false" [options]="mapOptions" [zoom]="zoom">
    @if (!displayRoute) {
      <map-marker [position]="center" [icon]="icon" [title]="title"> </map-marker>
    }
    @if (!displayRoute) {
      @for (pin of pins; track pin) {
        <map-marker [position]="pin" [title]="pin.message"> </map-marker>
      }
    }
    <core-map-content (onMapLoad)="loadAPIWrapper($event)"></core-map-content>
    @if (directionsResults$ | async; as directionsResults) {
      <map-directions-renderer [directions]="directionsResults" />
    }
  </google-map>
</div>
